import "src/css/agents.css";
import { Col, Row, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useTranslation } from 'react-i18next';
import { useState, useEffect, useRef } from "react";
import { connect } from 'react-redux';
import useMonitorAPIService from 'src/services/monitorapiservice';
import { abbreviate } from "src/components/utils/utils";
import Group from "./group";
import GroupStats from "./groupstats";
import Toastr from "src/components/utils/toastr";

function Groups(props) {

    const { t } = useTranslation();
    const { changeGroupStatus, changeGroupPriority } = useMonitorAPIService();
    const [dir, setDir] = useState("asc");
    const [groups, setGroups] = useState([]);
    const [allGroups, setAllGroups] = useState([]);
    const { getSupervisedGroupsStats } = useMonitorAPIService();
    const [selectedGroup, setSelectedGroup] = useState(null);
    const toastrRef = useRef(null);
    const [filter, setFilter] = useState(localStorage.getItem("groupsFilter") || "");

    useEffect(() => {
        loadGroups();
        var interval = setInterval(() => {
            loadGroups();
        }, (5000));
        return () => {
            // component unmounts
            localStorage.removeItem("selectedGroupId");
            localStorage.removeItem("groupsFilter")
            clearInterval(interval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadGroups = () => {
        getSupervisedGroupsStats(props.token, (res) => {
            var groupId = localStorage.getItem("selectedGroupId");
            var group = null;
            
            if (res.data != null && res.data.length > 0) {
                res.data.forEach((v, i) => {

                    v.initials = abbreviate(v.groupName);
                    v.selected = false;
                    if (groupId !== null && v.groupId === parseInt(groupId)) {
                        v.selected = true;
                        group = v;
                    }
                });

                let filter = localStorage.getItem("groupsFilter");
                let sort = localStorage.getItem("groupsSortDir")
                let filteredGroups = res.data;

                if (filter !== null && filter !== "")
                    filteredGroups = res.data.filter(x => x.groupName.toLowerCase().indexOf(filter) > -1);

                if (sort === "asc") {
                    filteredGroups.sort(function (a, b) {

                        const nameA = a.groupName.toLowerCase();
                        const nameB = b.groupName.toLowerCase();

                        if (nameA < nameB) {
                            return -1;
                        } else if (nameA > nameB) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                } else {
                    filteredGroups.sort(function (a, b) {
                        const nameA = a.groupName.toLowerCase();
                        const nameB = b.groupName.toLowerCase();

                        if (nameA > nameB) {
                            return -1;
                        } else if (nameA < nameB) {
                            return 1;
                        } else {
                            return 0;
                        }

                    });
                }


                setAllGroups(res.data);
                setSelectedGroup(group);
                setGroups(filteredGroups);


            }
        });
    }
    const handleChange = (e) => {
        let filter = e.target.value.toLowerCase();
        let filteredGroups = allGroups.filter(x => x.groupName.toLowerCase().indexOf(filter) > -1);
        setGroups(filteredGroups);
        setFilter(filter);
        localStorage.setItem("groupsFilter", filter);
    }

    const handleSort = (e) => {
        let sort = dir === "asc" ? "desc" : "asc";
        if (sort === "asc") {
            groups.sort(function (a, b) {

                const nameA = a.groupName.toLowerCase();
                const nameB = b.groupName.toLowerCase();

                if (nameA < nameB) {
                    return -1;
                } else if (nameA > nameB) {
                    return 1;
                } else {
                    return 0;
                }
            });
        } else {
            groups.sort(function (a, b) {
                const nameA = a.groupName.toLowerCase();
                const nameB = b.groupName.toLowerCase();

                if (nameA > nameB) {
                    return -1;
                } else if (nameA < nameB) {
                    return 1;
                } else {
                    return 0;
                }

            });
        }
        setGroups(groups);
        setDir(sort);
        localStorage.setItem("groupsSortDir", sort);
    }

    const selectGroup = (group) => {
        setSelectedGroup(group);
        localStorage.setItem("selectedGroupId", group.groupId);
        setGroups(prevState =>
            prevState.map(g =>
                g.groupId === group.groupId ? { ...g, selected: true } : { ...g, selected: false }
            )
        );
        setAllGroups(prevState =>
            prevState.map(g =>
                g.groupId === group.groupId ? { ...g, selected: true } : { ...g, selected: false }
            )
        );


    }

    const updateGroupState = (group, state) => {

        let data = {
            group: group.groupId,
            closed: state === false,
            automatic: state === null
        }

        setGroups(prevState =>
            prevState.map(g =>
                g.groupId === group.groupId ? { ...g, opened: state, automatic: state === null } : g
            )
        );
        setAllGroups(prevState =>
            prevState.map(g =>
                g.groupId === group.groupId ? { ...g, opened: state, automatic: state === null } : g
            )
        );

        setSelectedGroup(prevState => ({
            ...prevState,
            opened: state,
            automatic: state === null
        }));

        changeGroupStatus(props.token, data, res => {
            if (!res.data) {
                toastrRef.current.setType("error");
                toastrRef.current.setMessage(t("error"));
                toastrRef.current.show();
            } else {
                toastrRef.current.setType("success");
                toastrRef.current.setMessage(t("dataupdated"));
                toastrRef.current.show();
            }
        });
    }

    const updateGroupPriority = (group, priority) => {

        let data = {
            group: group.groupId,
            priority: priority
        }

        setGroups(prevState =>
            prevState.map(g =>
                g.groupId === group.groupId ? { ...g, priority: priority, } : g
            )
        );
        setAllGroups(prevState =>
            prevState.map(g =>
                g.groupId === group.groupId ? { ...g, priority: priority } : g
            )
        );

        setSelectedGroup(prevState => ({
            ...prevState,
            priority: priority
        }));

        changeGroupPriority(props.token, data, res => {
            if (!res.data) {
                toastrRef.current.setType("error");
                toastrRef.current.setMessage(t("error"));
                toastrRef.current.show();
            } else {
                toastrRef.current.setType("success");
                toastrRef.current.setMessage(t("dataupdated"));
                toastrRef.current.show();
            }

        });
    }
    return (

        <Row>
            <Col xs={3}>
                <div className='agents-list'>
                    <Row className='searchagents'>
                        <Col xxl={11} lg={10}>
                            <FontAwesomeIcon className='searchicon' icon={solid("magnifying-glass")} />
                            <Form.Control className='searchinput' value={filter} type="text" placeholder={t("search")} onChange={handleChange}></Form.Control>
                        </Col>
                        <Col xxl={1} lg={2}>
                            <Button variant='light-primary' className='filterbutton' onClick={handleSort}>
                                {
                                    (dir !== "asc") &&
                                    <FontAwesomeIcon icon={solid("arrow-up-wide-short")} />
                                }
                                {
                                    (dir === "asc") &&
                                    <FontAwesomeIcon icon={solid("arrow-down-wide-short")} />
                                }
                            </Button>
                        </Col>
                    </Row>
                    <div className="agents">
                        {
                            groups.map(v => {
                                return <Group key={v.groupId} group={v} selectGroup={selectGroup} ></Group>
                            })
                        }
                    </div>
                </div>
            </Col>
            <Col xs={9}>
                <div className='agent-settings'>
                    {
                        selectedGroup !== null &&
                        <GroupStats group={selectedGroup} updateGroupState={updateGroupState} updateGroupPriority={updateGroupPriority}></GroupStats>
                    }
                </div>
            </Col>

            <Toastr ref={toastrRef} />
        </Row>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
    };
};

export default connect(mapStateToProps, {})(Groups);